import { environment } from '@environments/environment';

export class FilesApiConstants {
  static organizations =
    environment.serverUri + `api/${environment.apiVersion}/organizations`;

  static formDocument = {
    prepareDownload: (documentId: string) => {
      return `${environment.serverUri}api/${environment.apiVersion}/form-documents/prepare-download/${documentId}`;
    },
    download: () => {
      return `${environment.serverUri}api/${environment.apiVersion}/form-documents/download`;
    },
  };

  static document = {
    list: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/browse`;
    },
    sharedList: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/browse-shared`;
    },
    sharingOrganizations: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/sharing-organizations`;
    },
    sharedListByOwner: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/browse-shared/by-owner`;
    },
    tagFiles: (organizationId: string, includeSponsorDocs: boolean = false) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/browse/tagged` +
        (includeSponsorDocs === true ? '?includeSponsorDocs=true' : '?includeSponsorDocs=false');
    },
    tag: {
      user: (organizationId: string) => {
        return `${FilesApiConstants.organizations}/${organizationId}/documents/tag/user`;
      },
      system: (organizationId: string) => {
        return `${FilesApiConstants.organizations}/${organizationId}/documents/tag/system`;
      },
      disassociate: (organizationId: string) => {
        return `${FilesApiConstants.organizations}/${organizationId}/documents/tag/disassociate`;
      },
      delete: (organizationId: string) => {
        return `${FilesApiConstants.organizations}/${organizationId}/documents/tag/delete`;
      },
    },
    copy: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/copy`;
    },
    move: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/move`;
    },
    delete: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/delete`;
    },
    download: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/download`;
    },
    downloadToken: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/download/token`;
    },
    sharedExportEstimate: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/shared-export/estimate`;
    },
    sharedExportDownloadToken: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/shared-export/download/token`;
    },
    sharedExportSubmit: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/shared-export/submit`;
    },
    documentExports: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/document-exports`;
    },
    documentExport: (organizationId: string, jobId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/document-exports/${jobId}`;
    },
    documentExportDownload: (organizationId: string, jobId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/document-exports/${jobId}/download`;
    },
    path: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/path`;
    },
    editName: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/edit-name`;
    },
    share: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/share`;
    },
    upload: (organizationId: string) => {
      return `${FilesApiConstants.organizations}/${organizationId}/documents/upload`;
    },
  };
}
